module.exports = __webpack_public_path__ + "img/exomega_packs.topps.d7fe8b2.png";